import { render, staticRenderFns } from "./FollowupPatients.vue?vue&type=template&id=79d3b7fd&scoped=true"
import script from "./FollowupPatients.vue?vue&type=script&lang=js"
export * from "./FollowupPatients.vue?vue&type=script&lang=js"
import style0 from "./FollowupPatients.vue?vue&type=style&index=0&id=79d3b7fd&prod&scoped=true&lang=css"
import style1 from "./FollowupPatients.vue?vue&type=style&index=1&id=79d3b7fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d3b7fd",
  null
  
)

export default component.exports